import {
  AdditionalSearchFilters,
  SearchFilters,
} from '@page/search/search.types'
import { DEFAULT_SEARCH_GUESTS } from '@utils/guest-counts'

export const defaultAdditionalSearchFilters: AdditionalSearchFilters = {
  sortBy: 'recommended',
  distance: 30,
  keywords: '',
  dynamicFilters: [],
}

// Re-exported so existing search/filter call sites keep their import path.
// The constant itself lives in @utils/guest-counts alongside the helpers that
// compare against it — see hasSelectedGuests.
export { DEFAULT_SEARCH_GUESTS }

export const defaultSearchFilters: SearchFilters = {
  value: '',
  date: undefined,
  start: undefined,
  end: undefined,
  flexibleDuration: undefined,
  flexibleStartRangeHours: undefined,
  timeType: 'specific',
  guests: {
    ...DEFAULT_SEARCH_GUESTS,
  },
  ...defaultAdditionalSearchFilters,
}
